import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Search } from "lucide-react";
import Seo from "@/components/Seo";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [q, setQ] = useState("");
  const load = (query = "") => api.get(`/blog${query ? `?q=${encodeURIComponent(query)}` : ""}`).then((r) => setPosts(r.data));
  useEffect(() => { load(); }, []);
  const featured = posts.find((p) => p.featured) || posts[0];
  const rest = posts.filter((p) => p !== featured);

  return (
    <div>
      <Seo
        title="Journal — essays on strength, movement, nutrition & recovery"
        description="The Kore Wellbeing journal — long-form essays on coached training, mobility, nutrition without dogma, recovery and the boring habits that quietly outperform every fad."
        path="/blog"
      />
      <section className="container-kore pt-16 pb-8 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div>
          <span className="eyebrow">Journal</span>
          <h1 className="display-1 mt-4 text-kore-forest">Notes, essays, ideas.</h1>
        </div>
        <div className="relative">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-kore-ink/40" />
          <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load(q)} placeholder="Search" data-testid="blog-search" className="pl-9 pr-4 py-2.5 rounded-full border border-kore-gold/30 bg-transparent text-sm focus:outline-none focus:border-kore-gold w-72" />
        </div>
      </section>

      {featured && (
        <section className="container-kore py-12">
          <Link to={`/blog/${featured.slug}`} data-testid="blog-featured" className="grid md:grid-cols-2 gap-10 items-center group">
            <div className="aspect-[4/3] rounded-3xl overflow-hidden">
              <img src={featured.cover_image} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-[0.24em] text-kore-gold">{featured.category} · Featured</div>
              <h2 className="display-2 mt-4 text-kore-forest group-hover:text-kore-gold/90 transition">{featured.title}</h2>
              <p className="mt-4 text-kore-ink/70 leading-relaxed">{featured.excerpt}</p>
              <span className="mt-6 inline-block text-xs uppercase tracking-[0.24em] text-kore-forest border-b border-kore-gold pb-1">Read essay</span>
            </div>
          </Link>
        </section>
      )}

      <section className="container-kore pb-24 grid md:grid-cols-3 gap-10">
        {rest.map((p) => (
          <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden mb-5">
              <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="text-[11px] uppercase tracking-[0.24em] text-kore-gold">{p.category}</div>
            <h3 className="font-display text-2xl mt-2 text-kore-forest group-hover:text-kore-gold/90 transition">{p.title}</h3>
            <p className="mt-2 text-sm text-kore-ink/70 font-light">{p.excerpt}</p>
          </Link>
        ))}
      </section>
    </div>
  );
}
